import axios from 'axios';
import { useConfirm } from 'material-ui-confirm';
import React, { useEffect, useRef, useState } from 'react';

const ImageUploadComponent = (props: any) => {
    const [src, setSrc] = useState<any>();
    const refInputImage = useRef<any>();
    const confirm = useConfirm();
    const defaultImage = `${axios.defaults.baseURL}../${props.default}`;

    useEffect(() => {
        setSrcOrDefault(props.model[props.field]);
    }, [props.model]);

    function setValue(value: any) {
        props.model[props.field] = value;
        setSrcOrDefault(value);
    }

    function setSrcOrDefault(value: any)
    {
        if (value == null){
            setDefaultSrc();
            return;
        }

        const path = `${axios.defaults.baseURL}../files/${value}`
        setSrc(path);
    }

    const uploadFilesAsync = async (files: FileList | null) => {
        if (files == null) {
            return;
        }

        if (files && files[0]) {
            var file = new FileReader();
            file.onload = function(e) {
                setSrc(e?.target?.result);
            };

            file.readAsDataURL(files[0]);
            setValue(files[0]);
            props.model[props.uploadedField] = files[0];
            
        }
    }

    async function clearAsync() {
        await confirm({ title: "Deseja realmente remover o logotipo?" });
        props.model[props.field] = null;
        setDefaultSrc();
    }

    function setDefaultSrc() {
        if (props.default==null)
        {
            setSrc(null);
            return;
        } 

        setSrc(defaultImage);
    }

    return (
        <div className={props.className}>
            <label>{props.label}</label>
            <button type='button' className='btn btn-close btn-clear-image' onClick={clearAsync} hidden={src==null || defaultImage == src} />
            <input name={props.field} ref={refInputImage} type="file" accept="image/*" onChange={(e: any) => uploadFilesAsync(e.target.files)} hidden /><br />
            <img src={src} style={{maxWidth: '130px', marginTop: '2px', width: '100%', height: '100px'}} onClick={() => refInputImage?.current?.click()} />
        </div>
    );
}

export default ImageUploadComponent;
